import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=650f19c0&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=650f19c0&prod&lang=css"
import style1 from "./Statistics.vue?vue&type=style&index=1&id=650f19c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f19c0",
  null
  
)

export default component.exports